import React from "react";

import BoxHeader from './BoxHeader.jsx'
import BoxBody from "./BoxBody.jsx";

const App = () => {
	const data = window.icons.icons;
	const currentBlogId = window.icons.blog_id;

    const handleMouseEnter = (e) => {
        const id = e.currentTarget.id;
        const text = document.getElementById(`${id}text`)

        e.currentTarget.classList.add('active');
        text.classList.add('active');
    }
    const handleMouseLeave = (e) => {
        const id = e.currentTarget.id;
        const text = document.getElementById(`${id}text`)

        e.currentTarget.classList.remove('active');
        text.classList.remove('active');
    }

    const mapBoxes = () => {
        let renderBoxes;
        
        if (data) {
			renderBoxes = data.map((field, index) => {
				return <BoxHeader
					id={index}
					key={index + field.box_title}
					icon={field.box_icon} 
					url={field.box_url}
					title={field.box_title}
					blogId={currentBlogId}
					onMouseEnter={handleMouseEnter}
					onMouseLeave={handleMouseLeave}
				/>
			});
        }

        return renderBoxes;
    }

    const mapTextBoxes = () => {
        let renderText;

        if ( data ) {
			renderText = data.map( (field, index) => {
				return <BoxBody id={index} key={index} text={field.box_text} />
			})
        }
        
        return renderText;
    }

    return (
        <div className="boxes hidden-mobile">
            <div className="box-wrapper">
                {mapBoxes()}
            </div>
            <div className="boxes-text">
                <div className="box-body">
                    {mapTextBoxes()}
                </div>
            </div>
        </div>
    );

}

export default App;